module.exports = __webpack_public_path__ + "static/media/r7s1.bf598917.jpg";